import {
  numberOnly,
  isEmail,
  isPhone,
  moreThanLength,
  lessThanLength,
  betweenLength,
} from '~components/common/forms/UniversalValidations.js'

export const VisitCounselingFormBlueprint = [
  {
    key: 'department_id',
    type: 'select',
    div: 3,
    disabled: true,
    label: '就讀系/所：',
  },
  {
    type: 'input',
    key: 'student_account',
    div: 3,
    disabled: true,
    required: true,
    max_length: 500,
    label: '學號：',
  },
  {
    type: 'input',
    key: 'student_name',
    div: 3,
    disabled: true,
    max_length: 500,
    required: true,
    label: '姓名：',
  },
  {
    type: 'input',
    key: 'internship',
    div: 2,
    max_length: 500,
    disabled: true,
    required: true,
    label: '實習單位：',
  },
  {
    type: 'input',
    key: 'work_department',
    div: 2,
    required: true,
    max_length: 500,
    label: '部門別（上班班別）：',
  },
  { type: 'hr' },
  {
    type: 'input',
    key: 'manager',
    div: 3,
    max_length: 500,
    required: true,
    label: '單位主管姓名：',
    square_width: '176px',
  },
  {
    type: 'output_button',
    custom_type: 'date',
    key: 'counseling_date',
    div: 3,
    label: '輔導日期：',
    icon: 'date',
    square_width: '176px',
    check: (cur_val) => {
      if(!cur_val) return '必填';
    },
  },
  { type: 'br' },
  {
    type: 'outer',
    key: 'visit_outer',
    class_name: 'flex_row',
    blocks: [
      {
        type: 'label',
        div: 'auto',
        text: '訪視方式：',
      },
      {
        type: 'radio',
        key: 'visit',
        div: 'auto',
        required: true,
        list_style: 'column',
        options: ['電話訪視', '親自訪視', '視訊訪視'],
        values: [1, 2, 3],
      },
      {
        type: 'input',
        key: 'visit_tel',
        div: 'auto',
        class_name: 'flex_row',
        label: 'TEL：',
        max_length: 500,
        square_height: '25px',
      }
    ],
  },
  {
    type: 'radio',
    key: 'provide_stay',
    class_name: 'flex_row',
    required: true,
    label: '住宿調查：',
    options: ['家裡', '學校宿舍', '公司宿舍', '租屋'],
    values: [1, 2, 3, 4],
  },
  { type: 'hr' },
  {
    type: "label",
    text: '學生實習概況：（依據與學生訪談狀況給分）',
  },
  {
    type: 'radio_table',
    key: 'student_check',
    required: true,
    label: '提項',
    options: ['極佳', '佳', '可', '不佳', '極不佳'],
    items: [
      '1.工作態度與積極度',
      '2.工作量合理性',
      '3.工作內容熟悉程度',
      '4.工作出勤情形',
      '5.工作執行表現能力',
      '6.工作與同事相處情形',
      '7.工作與主管相處情形',
      '8.學習態度與精神',
      '9.對實習單位滿意程度',
    ],
  },
  { type: 'hr' },
  {
    type: "label",
    text: '實習廠商對於實習學生安排與規劃：（依據與實習單位主管訪談狀況給分）',
  },
  {
    type: 'radio_table',
    key: 'intern_check',
    required: true,
    label: '提項',
    options: ['極佳', '佳', '可', '不佳', '極不佳'],
    items: [
      '1.工作內容與簽約內容符合',
      '2.是否有工作不當之分配',
      '3.工作量是否合理',
      '4.工作中與主管相處情形',
      '5.工作中與同事相處情形',
      '6.是否安排職前與在職訓練',
    ],
  },
  { type: 'hr' },
  {
    type: 'textarea',
    key: 'comments',
    required: true,
    max_length: 500,
    label: '綜合評語：',
    max_length: 500,
    placeholder: '請輸入綜合評語',
  },
  {
    type: 'input',
    key: 'intern_teacher',
    div: 4,
    required: true,
    label: '實習輔導教師：',
    max_length: 500,
    square_width: '176px',
  },
  {
    type: 'input',
    key: 'school_manager',
    div: 4,
    required: true,
    max_length: 500,
    label: '教學單位主管：',
    square_width: '176px',
  },
];